export default {
  pageTitle: 'Fund account',
  hasBindAcc: 'The current store already has a fund account',
  accUserId: 'Fund account No.',
  accSubUserId: 'Billing subaccount No.',
  accList: 'Fund account list',
  balance: 'Avail balance',
  notAmount: 'Locked Amount',
  accOpenType: 'Please choose Fund account opening method',
  bindOtherAcc: 'Bind to an existing fund account ',
  openNewAcc: 'Apply for a new fund account',
  confirm: 'Confirm',
  accountType256: 'Cash',
  accountType512: 'Credit Account',
  accountType513: 'Credit Pita',
  accountType1280: 'Points',
  accountType144: 'Billing Account',
  accountType128: 'Head logistics balance Account',
  accountType110: 'Margin Account',

  // dialog apply
  applyTitle: 'Apply for a new fund account',
  curStore: 'Main enterprise of the store',
  businessLicense: 'Business license/VAT No.',
  companyName: 'Company Name',
  openTips: 'A new fund account will be created with this information',
  hasBind: 'The current store already has a fund account',
  accBindPhone: 'The bind Phone No. of this fund account',
  send: 'Send',
  hasRead: 'I have read and agree to the Kilimall Merchant Fund Account Opening Agreement',
  applyCreate: 'Apply now',
  polyOk: 'Please agree with the Agreement first!',
  notSend: 'Please enter the code you received after you click "send code" button',

  // dialog bind
  bindTitle: 'The funding account you want to link must have the same business entity as the current business account',
  phoneErr: 'Phone No. incorrect',
  licenseErr: 'Business license incorrect',
  startBind: 'Bind Now',
  complete: 'Please enter the last 4 chars or numbers',
  sameCmp: 'Same business entities',
  notMainBody: 'We cannot find a fund account with the same business entity as your store, if you havn\'t a fund account please apply for a new one.',
  curMainBody: 'The business entity of current store',
  hasBusinessLicenseTips: 'The business license account has been opened, please select the binding operation',
  thisSectionIsTesting: ' This section is in testing, the data has not been verified.',

  // 账单下载
  billK: {
    title: 'Settlement Inquiry',
    billingPeriod: 'Settlement cycle',
    billDownload: 'Settlement report',
    downloadBill: 'Download',
    bankreceipt: 'Bank receipt',
    bill_text: 'If you have any questions about the settlement, please',
    customerService: 'contact merchant service support',
    weChatService: ' For details, please refer to FAQ ',
    shopFAQ: '<Kilimall Local Seller Settlement Policy>',
    completeInformation: 'Please contact the merchant service support to complete the settlement  cycle information.',
    pleaseChoose: 'Please select a Settlement cycle',
    chooseBill: 'Select Settlement period',
    notqueried: 'The Settelement report for the period you selected was not queried'
  },

  // 保证金
  margin: {
    storeMargin: 'Seller Security Deposit Account',
    openShopDeposit: 'Set up the shop guarantee account',
    activationSuccessful: 'Activation successful',
    // 以下的文案目前没用到，后续有需要就用，没需要可删除
    rechargeRecord: '充值记录',
    rechargeId: '记录Id',
    rechargeAccount: '充值账户',
    currency: '币种',
    rechargeAmount: '充值金额',
    rechargeTime: '充值时间',
    accountingDate: '到账时间',
    rechargeWay: '充值方式',
    marginCharge: '保证金充值',
    topUpImmediately: '马上充值',
    recharge: '充值',
    wechatRecharge: '微信充值',
    cancelPaid: '取消支付',
    havePaid: '我已支付',
    topUp: 'Top up',
    topUpTipOne: '1. 保证金充值必须使用商家入驻企业的对公帐户进行转帐或付款，否则会被退回，请充值时注意。',
    topUpTipTwo: '2. 付款时请确认收款对象为“xxxxxxxxxx公司”，避免意外问题和损失'
  },
  fbk: {
    fbkInventoryAppeal: 'FBK Inventory Appeal (Trial)',
    appealStatus: 'Appeal Status',
    all: 'All',
    pendingBusinessReview: 'Pending Business Review',
    pendingFinancialReview: 'Pending Financial Audit',
    pendingSettlement: 'Pending Settlement',
    rejected: 'Rejected',
    completed: 'Completed',
    productAppealSn: 'Product Appeal Number',
    mallSKUNumber: 'Mall SKU Number',
    wmsSKUNumber: 'WMS SKU Number',
    appealTime: 'Appeal Time',
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: '7D',
    wtd: 'WTD',
    mtd: 'MTD',
    qtd: 'QTD',
    threeMonth: '3Month',
    ytd: 'YTD',
    exportExcel: 'Export Excel',
    newAppeal: 'New Appeal',
    appealQty: 'Appeal Qty',
    approvedQty: 'ApprovedQty',
    displayedQty: 'Currently Displayed Qty',
    disputedUnitPrice: 'Appeal Unit Price',
    approvedPrice: 'Approved Unit Price',
    createTime: 'Create Time',
    businessReviewTime: 'Business Review Time',
    financialReviewTime: 'Financial Review Time',
    settlementCompletedTime: 'Settlement Completion Time',
    status: 'Status',
    operation: 'Operation',
    details: 'Details',
    cancel: 'Cancel',
    canceled: 'Cancelled',
    appeal: 'Appeal',
    newCreateFbkAppeal: 'New Merchant FBK Inventory Appeal (Details)',
    fbkAppealInfo: 'FBK Inventory Appeal (Details)',
    productStoreInfo: 'Product and Store Information',
    productName: 'Product Name',
    productSpec: 'Product Spec',
    salesUnitPrice: 'Selling Unit Price',
    WMSShowFBKQty: 'WMS Display (FBK) Inventory',
    latestQueryTime: 'Latest Query Time',
    affiliatedStore: 'Affiliated Store',
    appealInfo: 'Appeal Information',
    appealCurrency: 'Appeal Currency',
    appealExplain: 'Appeal Description',
    appealMaterialsUpload: 'Upload Appeal Materials',
    appealAcceptanceInfo: 'Appeal Processing Information',
    rejectStatement: 'Rejection Reason',
    check: 'Check',
    qty: 'Qty',
    theEditedValuePrice: 'The edited value cannot exceed the selling price.',
    cnEditedValuePriceTip: 'The value cannot exceed half of the selling unit price.',
    appealExplainTips: 'Appeal description is limited to 200 characters.',
    uploadTipText: 'Maximum of 5 attachments allowed (formats: PNG, JPG, PDF).Each attachment must not exceed 2MB in size.',
    settlementTime: 'Settlement Time',
    cancelAppeal: 'Cancel Appeal',
    submitAppeal: 'Submit Appeal',
    editAppeal: 'Edit Appeal',
    StoreNo: 'Store#',
    confirmCancel: 'Confirm cancellation',
    pleaseEnter: 'Please Enter',
    mustGreaterZero: 'Must be greater than 0'
  }
}
